<script lang="ts" setup>
import AiImage from '#layers/core/app/assets/img/ai-image.png';

const props = withDefaults(defineProps<{
    requiredFeatures?: AIFEATURE[];
    loading?: boolean;
    disabled?: boolean;
    variant?: string;
    icon?: string;
    size?: string;
    title?: string;
    text?: string;
}>(), {
    requiredFeatures: () => ['text-fast'] as AIFEATURE[],
    loading: false,
    disabled: false,
    variant: 'fancy',
    icon: 'sparkles',
    size: 'sm',
    title: '',
    text: ''
});

const emit = defineEmits<{
    click: [event: Event];
}>();

const { $t } = useLocalization();
const aiStore = useAiStore();
const rwd = useMedia();

const popoverId = `ai-action-btn-${Math.random().toString(36).substring(2, 9)}`;
const featuresConfigured = computed(() => aiStore.hasFeatures(...props.requiredFeatures));
const actionIcon = computed(() =>
{
    if ((props.variant ?? '').split(' ').includes('fancy'))
        return 'sparkles';

    return props.icon;
});
</script>

<template>
    <div v-if="!featuresConfigured && rwd.desktop()" :id="popoverId" class="inline-flex">
        <IdeoAction stop-propagation
            disabled
            :variant="variant"
            :icon="actionIcon"
            :size="size"
            :title="title"
            :text="text"
        />

        <IdeoPopover
            class="max-w-sm border-0 bg-gradient-to-br from-cyan-500 via-blue-500 to-purple-600 p-0.5 [&_.ideo-floating-body]:rounded-md [&_.ideo-floating-body]:bg-gray-50 [&_.ideo-floating-body]:p-0 dark:[&_.ideo-floating-body]:bg-gray-900"
            placement="bottom"
            :target="popoverId"
            triggers="hover"
        >
            <div>
                <img :src="AiImage" class="block max-h-36 w-full rounded object-cover">
                <div class="p-3">
                    <div class="mb-1 text-[1rem] font-[700]">
                        {{ $t('[[[Wypróbuj możliwości AI]]]') }}
                    </div>
                    <div class="mb-3 text-[0.875rem]">
                        {{ $t('[[[Przejdź do konfiguracji, aby włączyć narzędzia]]]') }}
                        <b>{{ $t('[[[AI]]]') }}</b>.
                    </div>
                    <IdeoAction stop-propagation class="w-full" variant="fancy" icon="sparkles" :text="$t('[[[Konfiguracja AI]]]')" :to="{ name: 'ai-settings' }" />
                </div>
            </div>
        </IdeoPopover>
    </div>

    <IdeoAction stop-propagation
        v-else
        :loading="loading"
        :disabled="!featuresConfigured || disabled"
        :variant="variant"
        :icon="actionIcon"
        :size="size"
        :title="title"
        :text="text"
        @click.prevent="emit('click', $event)"
    />
</template>
